export default "__VITE_ASSET__D2jUZQA5__"